<template>
  <div class="container">

    <div class="banner">
      <el-carousel height="460px">
        <el-carousel-item v-for="(v, i) in banner" :key="i">
          <a><img :src="v.img" alt=""></a>
        </el-carousel-item>
      </el-carousel>



      <!-- banner内的国家选择模块 -->
      <section class="box">
        <nav>
          <span :class="{ on: i === deploy.type }" v-for="(v, i) in nav" :key="v.url" @click="deploy.type = i">{{
            v.label }}</span>
        </nav>
        <!-- 签证模块 -->
        <div v-show="deploy.type === 0" class="visa">
          <!-- 顶部大洲模块 -->
          <ul class="tab">
            <li :class="{ on: i === deploy.visaCityIndex }" v-for="(v, i) in country" :key="v.id"
              @click="deploy.visaCityIndex = i">{{ v.text }}</li>
          </ul>
          <!-- 下方热门国家选择 -->
          <ul class="option" v-if="country[deploy.visaCityIndex]">
            <li :class="{ hot: v.is_hot }" v-for="v in country[deploy.visaCityIndex].countrys" :key="v.VisaCountryID"
              @click="goList(v)">{{ v.Name }}</li>
          </ul>
        </div>
        <!-- 酒店模块 -->
        <div v-show="deploy.type === 1" class="hotel">
          <ul class="tab">
            <li :class="{ on: deploy.hotelTypeIndex === 0 }" @click="deploy.hotelTypeIndex = 0">境内酒店</li>
            <li :class="{ on: deploy.hotelTypeIndex === 1 }" @click="deploy.hotelTypeIndex = 1">境外酒店</li>
          </ul>
          <ul class="option">
            <li>
              <span>目的地</span>
              <el-cascader v-model="submit.hotelCity" :options="getHotelCityList"
                :props="{ value: 'CityCode', label: 'CityName_CN' }" size="small"></el-cascader>
            </li>
            <li>
              <span>入住日期</span>
              <el-date-picker v-model="submit.hotelDate" size="small" type="daterange" range-separator="至"
                :picker-options="dateOptions" value-format="yyyy-MM-dd" start-placeholder="入住日期" end-placeholder="离店日期">
              </el-date-picker>
            </li>
            <li>
              <span>成人</span>
              <el-input-number v-model="submit.hotelAdult" size="small" :min="0" :max="10" label="成人"></el-input-number>
            </li>
            <li>
              <span>儿童</span>
              <el-input-number v-model="submit.hotelChild" size="small" :min="0" :max="10" label="儿童"></el-input-number>
            </li>
          </ul>
          <el-button type="primary" @click="toHotel">搜索</el-button>
        </div>
        <!-- 旅游模块 -->
        <div v-show="deploy.type === 2" class="tour">
          <ul class="tab">
            <li :class="{ on: i === deploy.tourCityIndex }" v-for="(v, i) in tour.list" :key="v.id"
              @click="deploy.tourCityIndex = i">{{ v.text }}</li>
          </ul>
          <ul class="option">
            <li>
              <span>出发地</span>
              <el-select v-model="submit.tourLeave" filterable size="small">
                <el-option v-for="v in tour.city" :key="v.id" :label="v.text" :value="v.id">{{ v.text }}</el-option>
              </el-select>
            </li>
            <li>
              <span>目的地</span>
              <el-cascader v-model="submit.tourDestination" :options="getTuorCity"
                :props="{ value: 'id', label: 'text' }" size="small"></el-cascader>
            </li>
            <li>
              <span>出发日期</span>
              <el-date-picker size="small" type="daterange" v-model="submit.tourDate" value-format="yyyy-MM-dd"
                range-separator="至" start-placeholder="入住日期" :picker-options="dateOptions" end-placeholder="离店日期">
              </el-date-picker>
            </li>
          </ul>
          <el-button type="primary" @click="toTour">搜索</el-button>
        </div>
      </section>

    </div>
    <main>

      <section class="recommend">
        <h2>热门签证</h2>
        <nav>
          <a :class="{ on: hotVisaIndex === i }" v-for="(v, i) in country" :key="v.id" @click="hotVisaIndex = i">{{
            v.text
            }}</a>
        </nav>
        <ul>
          <li v-for="v in getHotVisa" :key="v.VisaCountryID">
            <router-link :to="{ path: './visa_list', query: { id: v.VisaCountryID, name: v.Name } }">
              <div class="imgWrapper"> <img :src="v.wechat_img" :alt="v.Name" /></div>
              <figure>
                <p>{{ v.Name }}</p>
                <!-- <b>{{ v.starting_price }}</b> -->
                <b>{{ v.first_dealer_price ? setNormalPrice(v.first_dealer_price) : setNormalPrice(v.first_price) }}</b>
              </figure>
            </router-link>
          </li>
        </ul>
      </section>

      <!-- 预约动态模块 -->
      <!-- <section class="appointment">
        <h2>预约动态</h2>

        <ul class="appointTags">
          <li>全部</li>
          <li>瑞士</li>
        </ul>

        <figure class="appointWrap">
          <figcaption class="appointGroup">
            <div>国家:</div>
            <div>预约时间:</div>
            <div>预约城市:</div>
          </figcaption>
        </figure>


      </section> -->



    </main>


  

  </div>
</template>

<script>
import $visa from '@api/visa';
import $tour from '@assets/js/tool/tour';
import moment from 'moment';
import tool from '@assets/js/tool';

export default {
  components: {},
  data() {
    return {
      deploy: {
        type: 0,
        visaCityIndex: 0,
        tourCityIndex: 0,
        hotelTypeIndex: 0
      },
      submit: {
        // 旅游
        tourLeave: null,
        tourDestination: null,
        tourDate: [],
        // 酒店
        hotelCity: [],
        hotelDate: [],
        hotelAdult: 1,
        hotelChild: 0
      },
      tour: {},
      hotCity: {
        china: [],
        global: []
      },
      hint: true,
      nav: [{
        label: '签证',
        url: 'visa',
      },
      {
        label: '酒店',
        url: 'hotel',
      },
      {
        label: '旅游',
        url: 'tour',
      }
      ],
      banner: [],
      hot: [],
      hotVisaIndex: 0,
      country: [],
      countryIndex: null,
      dateOptions: {
        disabledDate(date) {
          const d = moment().diff(date, 'd');
          return d > 0;
        }
      }
    }
  },
  computed: {
    getHotelCityList() {
      const {
        hotelTypeIndex
      } = this.deploy;
      const {
        hotCity
      } = this;
      let res = hotCity[hotelTypeIndex === 0 ? 'china' : 'global'];
      res = res.map(v => {
        return {
          ...v,
          children: v.children.map(s => {
            const {
              CityCode,
              CityName_CN,
              id,
              path
            } = s;
            return {
              CityCode,
              CityName_CN,
              id,
              path
            };
          })
        }
      });
      return res;
    },
    getHotVisa() {
      const {
        hot,
        country,
        hotVisaIndex
      } = this;
      const item = country[hotVisaIndex];
      if (!item) {
        return [];
      }
      const countryCity = item.countrys;
      const showLen = 8;
      return countryCity.slice(0, showLen);
    },
    swiper() {
      return this.$refs.swiper.$swiper
    },
    getTuorCity() {
      const {
        list
      } = this.tour;
      const {
        tourCityIndex
      } = this.deploy;
      if (!list) {
        return [];
      }
      const res = list[tourCityIndex].children.map(v => {
        return {
          text: v.text,
          id: v.id,
          children: v.children.map(s => ({
            text: s.text,
            id: s.id
          }))
        }
      });
      return res;
    }
  },
  created() {
    this.getData();
    this.getBaseData();
    this.getHotelCity();
    // this.$notify({
    //   title: '网站平台升级更新通知！',
    //   dangerouslyUseHTMLString: true,
    //   position: 'bottom-right',
    //   message: `
    //     <div className="hint">
    //       <b>因网站平台能力更新升级，有部分变更，特此通知如下：</b>
    //     <p>1.老用户（登记手机号码的用户），需重新使用手机及验证码进行<a href="./register">注册</a>验证；</p>
    //     <p>2.已注册的手机号，可以通过<a href="./update_pwd">忘记密码</a>进行找回密码；</p>
    //     <p>3.历史订单查询，请使用<a target="_blank" href="http://old.cstravel.cn/">旧平台(http://old.cstravel.cn/)</a>访问。（<span class="warn">备注：不要在旧平台下单</span>）</p>
    //     <p>4.新平台钱包功能暂未开放，旧平台钱包余额只支持人工处理或联系跟单销售！（<span class="warn">服务电话：0755-22658484</span>）</p>
    //     </div>
    //   `
    // })
  },
  methods: {
    // 返回正常显示的价格
    setNormalPrice(price) {
      return tool.ConversionPrice(price)
    },

    async getHotelCity() {
      let chinaHotCity = await this.$axios.get('/didaApi/getDidaHotChinaCity');
      const [{
        children: globalHotCity
      }] = await this.$axios.get('/didaApi/getDidaHotCity');
      chinaHotCity = [{
        CityName_CN: '境内热门',
        children: chinaHotCity
      }];
      let hotCity = {
        china: chinaHotCity,
        global: globalHotCity
      };
      this.hotCity = hotCity;
    },
    toHotel() {
      const {
        hotelAdult: adult,
        hotelChild: child,
        hotelDate: time,
        hotelCity: [, cityCode]
      } = this.submit;
      const {
        hotelTypeIndex
      } = this.deploy;
      const city = this.hotCity[hotelTypeIndex === 0 ? 'china' : 'global'].reduce((obj, v) => {
        const res = v.children.find(s => {
          return s.CityCode === cityCode
        });
        res && (obj = res);
        return obj;
      }, {});
      const data = {
        adult,
        minor: child,
        time,
        city
      };
      this.$router.push({
        name: 'hotel_list',
        query: {
          data: JSON.stringify(data)
        }
      });
    },
    toTour() {
      const {
        tourDate: date,
        tourDestination: [, listId],
        tourLeave: city
      } = this.submit;
      this.$router.push({
        name: 'tour',
        query: {
          city,
          listId,
          date
        }
      });
    },
    // 旅游通用参数
    async getBaseData() {
      const {
        TourDepartureCity: city,
        TourDestination: list
      } = await $tour.getBaseData();
      this.tour = {
        city,
        list
      };
    },
    // 签证列表
    goList(item) {
      const {
        VisaCountryID: id,
        Name: name
      } = item;
      this.$router.push({
        name: 'visa_list',
        query: {
          id,
          name
        }
      });
    },
    getData() {
      $visa.getCountry().then(res => {
        const {
          banner,
          countryData
        } = res;
        this.banner = banner;

        // 2023-10-30 获取热门国家
        $visa.getHotSalesCountryInfo().then((res) => {
          let hotList = res.data[0]['countrys'];
          let otherList = res.data.splice(1, res.data.length - 1);

          otherList.map((item) => {
            item.countrys.map((item2) => {
              // item2.starting_price = item2.starting_price ? tool.ConversionPrice(item2.starting_price) : 0;
              hotList.map((item3) => {
                if (item2.VisaCountryID == item3.VisaCountryID) {
                  item2.is_hot = true;
                }
              })
            })
          })

          hotList.map((item) => {
            item.is_hot = true;
          })
          this.hot = hotList;
          this.country = otherList;
        })

        // 获取热门签证
        // const hots = countryData.reduce((arr, v) => {
        //   let hot = v.country.filter(sub => sub.is_hot === 0);
        //   hot = hot.map(sub => {
        //     sub.parentId = v.id;
        //     return sub;
        //   });
        //   return [...arr, ...hot];
        // }, []);
        // this.hot = hots;
        // this.country = countryData;
      })
    },
    slideDirection(attr) {
      this.swiper[attr]();
    },
    changeArea(index) {
      this.countryIndex = index;
    }
  }
}
</script>

<style scoped src="./index.css"></style>
